<template>
  <b-modal
    id="order-movements-locations"
    ref="modal"
    scrollable
    header-class="headerModal"
    centered
    size="xl"
    :title="`${$t('Locations')}`"
    hide-footer
    @hide="onCancel"
  >
    <p
      v-if="(productsInStockList.length == 0 && orderItemIds.length == 0) && buttonSubmited"
      style="color:red;"
    >
      {{ $t('ChoseOrderOrArticles') }}
    </p>
    <div
      :class="productsInStockList.length > 0 ? 'articles-found' : 'no-article-found'"
    >
      <h4>
        {{ $t('Articles') }}
      </h4>
      <LoadingWrapperSpinner
        :response-data="productsInStockList"
        :class="productsInStockList.length > 0 ? 'display-all-articles' : 'no-articles'"
      >
        <div
          v-for="(articles, index) in productsInStockList"
          :key="index"
          class="display-articles"
        >
          <!-- <div style="text-align:right;">
            <b-icon-trash
              style="cursor:pointer;"
              @click="removeProduct(index)"
            />
          </div> -->
          <b-form-group
            :label="$t('ArticleNumber')"
          >
            <b-form-input
              v-model="articles.articleNumber"
              disabled
            />
          </b-form-group>
          <b-form-group
            :label="$t('Amount')"
          >
            <b-form-input
              v-model.number="articles.amount"
              disabled
            />
          </b-form-group>
        </div>
      </LoadingWrapperSpinner>
    </div>
    <div
      :class="orderItemIds.length > 0 ? 'articles-found' : 'no-article-found'"
      style="margin-top:10px;"
    >
      <h4>
        {{ $t('Orders') }}
      </h4>
      <LoadingWrapperSpinner
        :response-data="orderItemIds"
        :class="orderItemIds.length > 0 ? 'display-all-articles' : 'no-articles'"
      >
        <div
          v-for="(orders, index) in orderItemIds"
          :key="index"
          class="display-articles"
        >
          <!-- <div style="text-align:right;">
            <b-icon-trash
              style="cursor:pointer;"
              @click="removeOrder(index)"
            />
          </div> -->
          <b-form-group
            :label="$t('OrderNumber')"
          >
            <b-form-input
              v-model="orders.orderNumber"
              disabled
            />
          </b-form-group>
          <b-form-group
            :label="$t('ArticleNumber')"
          >
            <b-form-input
              v-model="orders.articleNumber"
              disabled
            />
          </b-form-group>
        </div>
      </LoadingWrapperSpinner>
    </div>
    <div
      class="display-elements"
    >
      <b-form-group
        :label="$t('Location')"
      >
        <vue-select
          v-model="toLocation"
          :options="getLocationsByStoreIdName"
          label="locationName"
          :reduce="(e) => e.locationId"
          :placeholder="$t('SelectLocation')"
          style="width: 100%; min-width: 100%; max-width: 100%;"
        />
        <p
          v-if="toLocation == null && buttonSubmited"
          style="color:red;"
        >
          {{ $t('SelectLocation') }}
        </p>
      </b-form-group>
    </div>
    <div
      class="buttonsEverywhere"
      style="margin-top:1%;"
    >
      <button
        type="button"
        variant="none"
        class="buttonSubmit"
        @click="onSubmit"
      >
        <div
          v-if="loading"
          style="width:100%"
          class="pdf-spinner-overlay"
        >
          <span class="loader" />
        </div>
        {{ $t('Submit') }}
      </button>
      <b-button
        type="reset"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>

    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'


export default {
  components: {
  },
  props: ['productsInStockList', 'orderItemIds'],
  data() {
    return {
      buttonSubmited: false,
      loading: false,
      toLocation: null,
    }
  },
  computed: {
    ...mapGetters([
      'getLocationsByStoreIdName',
    ]),
  },
  mounted() {
  },
  methods: {
    ...mapActions([
      'loadReceiverProductInStockFromInternal',
      'loadReceiverOrderFromInternal',
    ]),
    removeProduct(index) {
      this.productsInStockList.splice(index, 1);
    },
    removeOrder(index) {
      this.orderItemIds.splice(index, 1);
    },
    async onSubmit() {
      this.buttonSubmited = true;

      if (this.productsInStockList.length == 0 && this.orderItemIds.length == 0) {
        return;
      }

      if (this.toLocation == null) {
        return;
      }

      const objectProducts = this.productsInStockList.length > 0 ? this.productsInStockList.map((item) => {
        return {
          productInStockMovementId: item.productInStockMovementId,
          productInStockId: item.productInStockId,
          amount: item.amount,
          receivedAmount: item.amount,
          locationId: this.toLocation,
        };
      }) : null;
      const objectOrders = this.orderItemIds.length > 0 ? this.orderItemIds.map((item) => {
        return {
          lineItemMovementId: item.lineItemMovementId,
          windowItemId: item.windowItemId,
          locationId: this.toLocation,
        };
      }) : null;
      let hasError = false;
      try {
        this.loading = true;
        const promises = [];

        if (objectProducts) {
          promises.push(
            this.loadReceiverProductInStockFromInternal({
              object: objectProducts,
              successCallback: () => {
              },
            }),
          );
        }
        if (objectOrders) {
          promises.push(
            this.loadReceiverOrderFromInternal({
              object: objectOrders,
              successCallback: () => {
              },
            }),
          );
        }
        await Promise.all(promises);
      } catch (error) {
        hasError = true;
        console.error('Error occurred:', error);
      } finally {
        this.loading = false;
        if (!hasError) {
          this.loading = false;
          this.$refs.modal.hide();
          this.onReset();
          this.$emit('updateOrderMovementsDetails');
        }
      }
    },
    onCancel() {
      this.onReset();
      this.$emit('removeListsOrderArticle');
    },
    onReset() {
      this.buttonSubmited = false
      this.loading = false
      this.toLocation = null
      this.$refs.modal.hide();
    },
  },
}
</script>

<style lang="scss" scoped>
    .display-articles {
        border: 1px solid lightgrey;
        border-radius:12px;
        padding: 10px;
    }
    .display-all-articles {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }
    .no-articles {
        text-align:left;
    }
    .no-article-found {
        border: 1px solid lightgrey;
        border-radius:12px;
        padding: 10px;
    }
    .articles-found {
        padding: 10px;
        border: 1px solid lightgrey;
        border-radius:12px;
    }
    .display-elements {
        border: 1px solid lightgrey;
        border-radius:12px;
        padding: 10px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 5px;
        margin-top:10px;
    }
</style>
